import {style2} from '../signup/main.css'
import {style1} from './main.css'

import { LoadingOutlined, WarningOutlined, CheckOutlined } from '@ant-design/icons';
import { Space, Spin,  } from 'antd';
import { useLocation,useNavigate  } from "react-router-dom";

import callAPI from '../../comps/fetch/main'
import { useEffect, useState, useRef  } from 'react';
import logo from '../../images/logo.png'


function IGAUTHAPP() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isFBAPI, setIsFBAPI] = useState(undefined);
    const apiCalled = useRef(false); // Ref to prevent multiple calls

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.href.split('#')[1]);

    let app_url = `instantdm://pages/ig-connect?code=${new URL(window.location.href).searchParams.get('code')}`
    useEffect(() => {
       
        // console.log("=-=-=-=-appp url", app_url)
        window.location.assign(app_url);
 
    }, [data]);

    return (
        <div className="fb-rdr">
            <div className="core-fb-rdr">
                <div className="flex-space-between">
                    <img className="logo" src="/logo192.png"alt="Logo" style={{ height: '62px', width: '62px' }} />
                    <div className="button-left">
                        <a href="https://instagram.com/instant.dm" target="_blank" rel="noopener noreferrer" className="help">Need Help?</a>
                    </div>
                </div>
                <div className="center-content">
                    
                <p style={{ textAlign: 'center' }}>
                    <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />
                    Opening App...
                </p>
            

            
                <a href={app_url} style={{ marginTop: '20px' }} className="connect-fb">
                    Open App
                </a>
                    

                </div>
            </div>
        </div>
    );
}



export default IGAUTHAPP;
